import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { WorkOrderService } from '../../../../services/workorder.service';
import { DealerState } from '../../../../../../shared/state/DealerState';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelTitle } from '@angular/material/expansion';
import { EmptyStateModule, ModalModule, TableModule } from '@michelin/theme';
import { TranslationService } from '../../../../../../shared/translations/services/translation.service';
import { TranslationState } from '../../../../../../shared/state/TranslationState';
import { Subject, filter, takeUntil } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-audit-trail-tab',
  templateUrl: './audit-trail-tab.component.html',
  imports: [MatAccordion, MatExpansionPanel, MatExpansionPanelTitle, ModalModule, TableModule, EmptyStateModule, MatProgressSpinnerModule],
  styleUrls: ['./audit-trail-tab.component.scss']
})
export class AuditTrailTabComponent implements OnInit, OnDestroy {
  @Input() workOrderLineId!: string;
  @Input() workOrderHeaderId!: string;
  @Output() dataChanged = new EventEmitter<any>();
  @Output() hasChanges = new EventEmitter<boolean>();

  shopFloorTableConfig: any;

  shopFloorAuditTrail = new MatTableDataSource<any>([]);
  private destroy$ = new Subject<void>();
  loadingAuditTrail = false; // added

  public route = inject(ActivatedRoute);
  public store = inject(Store);
  public workOrderService = inject(WorkOrderService);
  public translationService = inject(TranslationService);

  constructor() {
    this.workOrderLineId = this.route.snapshot.paramMap.get('workOrderLineId');
    this.workOrderHeaderId = this.route.snapshot.paramMap.get('workOrderId');
  }

  ngOnInit(): void {
    // Build initial config (in case translations already loaded)
    this.buildTableConfig();
    // Rebuild config whenever language translations change
    this.store
      .select(TranslationState.currentLanguageTranslations)
      .pipe(
        filter((t) => !!t),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.buildTableConfig());
  }

  loadData(): void {
    this.loadShopFloorAuditTrail();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private buildTableConfig(): void {
    this.shopFloorTableConfig = {
      columns: {
        plant: { header: this.translationService.translate('workOrderLineDetailsPlantSiteText'), cell: (row: any) => row.plantSetupFk },
        userid: { header: this.translationService.translate('workOrderLineDetailsUserText'), cell: (row: any) => row.userFK },
        date: {
          header: this.translationService.translate('dateText'),
          cell: (row: any) => row.creationDateIso
        },
        post: { header: this.translationService.translate('workOrderLineDetailsPostText'), cell: (row: any) => row.postName },
        action: { header: this.translationService.translate('actionText'), cell: (row: any) => row.action }
      }
    };
  }

  private loadShopFloorAuditTrail(): void {
    const dealer = this.store.selectSnapshot(DealerState.currentDealer);
    if (!dealer?.id || !this.workOrderHeaderId || !this.workOrderLineId) {
      return;
    }
    this.loadingAuditTrail = true;
    this.workOrderService
      .fetchWolShopFloorAuditTrailInfo(
        dealer.id,
        this.workOrderHeaderId,
        this.workOrderLineId,
        Intl.DateTimeFormat().resolvedOptions().timeZone
      )
      .pipe(finalize(() => (this.loadingAuditTrail = false)))
      .subscribe((response) => {
        this.shopFloorAuditTrail.data = response?.data || [];
      });
  }
}
